import { handleEntriesTopVehicles } from "../../../api/entries";
import { ExportToExcel } from "../../../utils/exportExcel";
import { useQuery } from "@tanstack/react-query";
import { Button, Drawer, Form, Space, Input, Table } from "antd";
import { useState } from "react";
import { Download, Funnel, X } from "lucide-react";
import AllEntries from "./AllEntries";

const { Search } = Input;

export default function AllModels({ isVisible, setVisible, filters }: any) {
  const [search, setSearch] = useState("");
  const [form] = Form.useForm();
  const [limit, setLimit] = useState<any>("all");
  const [vehicles, setVehicles] = useState([]);
  const [showVehicles, setShowVehicles] = useState(false);
  const [makeId, setMakeId] = useState("");
  const [title, setTitle] = useState("");

  const params = `limit=all&startDate=${filters?.startDate}&endDate=${filters?.endDate}&branch=${filters?.branch}`;

  const { data: entries, isLoading } = useQuery({
    queryKey: ["topModels", params],
    queryFn: () => handleEntriesTopVehicles({ params }),
  });

  const [pagination, setPagination] = useState<any>({
    page: 1,
    limit: 24,
    total: 0,
  });

  const handlePageChange = (e: any) => {
    setPagination((prev: any) => ({
      ...prev,
      page: e.current,
      limit: e.pageSize,
    }));
  };

  const handleClearSearch = () => {
    setSearch("");
    form.resetFields();
  };

  const columns: any = [
    {
      title: "S/N",
      width: 40,
      render: (record: any, text: any, index: any) => (
        <span className="text-gray-700 ml-2">
          {pagination?.page * pagination?.limit - pagination?.limit + index + 1}
        </span>
      ),
      fixed: "left",
    },
    {
      title: "MODEL",
      width: 100,
      render: (record: any) => (
        <span className="text-black">
          <span className="text-black capitalize">
            {record?.groupedModelName}
          </span>
          <span className="text-gray-500 mx-2">
            ({record?.uniqueMakeNames[0]})
          </span>
        </span>
      ),
    },
    {
      title: "ENTRIES",
      width: 140,
      fixed: "right",
      render: (record: any) => (
        <div className="flex items-center">
          <div className="">
            <span className="text-gray-500">( {record?.percentage}% )</span>
          </div>
        </div>
      ),
    },
    {
      title: "ACTION",
      width: 100,
      fixed: "right",
      align: "right",
      render: (record: any) => {
        return (
          <div className="flex justify-end">
            <button
              onClick={() => {
                setVehicles(record?.individualModels);
                setShowVehicles(true);
              }}
              className="flex items-center border px-2 bg-blue-50 hover:bg-blue-100"
            >
              View All
            </button>
          </div>
        );
      },
    },
  ];
  return (
    <Drawer
      title={
        <div className="flex items-center">
          <span className="mr-2 text-lg uppercase">All Models</span>
        </div>
      }
      placement={"right"}
      width={800}
      onClose={() => setVisible(!isVisible)}
      open={isVisible}
      closable={false}
      extra={
        <Space>
          <Button type="default" onClick={() => setVisible(!isVisible)} danger>
            <X size={16} />
          </Button>
        </Space>
      }
    >
      <div className="">
        <div className="flex justify-between items-center border-b border-gray-300 mb-2 pb-2 -mt-4 bg-white">
          <div className="flex">
            <Form layout="inline" form={form}>
              <Form.Item name="registration">
                <Search
                  placeholder="Search vehicle / model"
                  allowClear
                  onChange={(val: any) => {
                    setSearch(val.target.value);
                  }}
                  onSearch={(value: any) => {
                    setSearch(value);
                  }}
                />
              </Form.Item>

              <Button className="" onClick={() => handleClearSearch()}>
                <Funnel size={16} />
              </Button>
            </Form>
          </div>
          <div className="flex ">
            <button
              color="#E50000"
              className="flex justify-center items-center border p-1 hover:bg-green-100"
            >
              <Download size={16} />
              <span
                className="ml-2"
                onClick={() =>
                  ExportToExcel(
                    entries?.map((record: any, index: number) => {
                      return {
                        "S/N": index + 1,
                        "Vehicle / Model": record?.groupedModelName || "-",
                        Make: record?.uniqueMakeNames[0] || "-",
                        Entries:
                          `${record?.totalCount} ( ${record?.percentage}% )` ||
                          "-",
                      };
                    }),
                    "Vehicles.xlsx"
                  )
                }
              >
                Export To Excel
              </span>
            </button>
          </div>
        </div>

        <div className="shadow-sm">
          <Table
            size="small"
            dataSource={entries}
            columns={columns}
            scroll={{ y: 700, x: "max-content" }}
            rowKey="id"
            bordered
            pagination={{
              current: pagination?.page,
              pageSize: pagination?.limit,
              total: pagination?.total,
            }}
            rowClassName={"hover:bg-gray-100 cursor-pointer"}
            onChange={(e: any) => handlePageChange(e)}
            onRow={(record: any) => {
              return {
                onClick: () => {
                  setVehicles(record?.individualModels);
                  setMakeId(record?.uniqueMakeId[0]);
                  setTitle(`${record?.groupedModelName}`);
                  setShowVehicles(true);
                },
              };
            }}
            loading={isLoading}
          />
        </div>
      </div>
      <AllEntries
        isVisible={showVehicles}
        setVisible={setShowVehicles}
        vehicles={vehicles}
        makeId={makeId}
        title={title}
      />
    </Drawer>
  );
}
